let cicadaProductInfo = [
    {name: "供电方式", value: "电池供电（7Ah/24V）"},
    {name: "最大功率", value: "最大功率：54W（19度斜坡，最大速度0.58m/s行驶条件下测试数据）"},
    {name: "有线充电电流（时间）", value: "3A（3h30min）"},
    {name: "无线充电电流（时间）", value: "3A（3h30min）"},
    {name: "续航里程", value: "5km"},
    {name: "巡检速度", value: "0.026-0.589m/s可设定"},
    {name: "检测气体", value: "烟雾，甲烷，一氧化碳，氨气，硫化氢，PM2.5，PM10（可选，可定制）"},
    {name: "摄像头旋转角度", value: "水平（15~345度）垂直（75~180度）"},
    {name: "图像采集", value: "RGB网络摄像头，红外热成像"},
    {name: "声音采集", value: "驻极体电容麦"},
    {name: "避障方式", value: "前后激光雷达"},
    {name: "机器尺寸", value: "长345mmx宽245mmx高276mm"},
    {name: "行走机构", value: "4#角钢"},
    {name: "爬坡能力", value: "≤30°斜坡"},
    {name: "最小转向半径", value: "大于1.5m"},
    {name: "夜视补光方式", value: "红外光辅助"},
    {name: "抗电磁干扰能力", value: "可在电磁和射频干扰下（频率400-500MHz，功率5W）正常工作"},
    {name: "防护等级", value: "IP65"},
    {name: "重量", value: "净重8.85kg（裸机）"},

]


let cicadaProvince = [
    {name: "工作温度", value: "-10～50℃"},
    {name: "存储温度", value: "-30～75℃"},
    {name: "工作湿度", value: "5～95%，无冷凝"},
]

let cicadaMAProductInfo = [
    {name: "供电方式", value: "电池供电（10Ah/12V）"},
    {name: "最大功率", value: "最大功率：50W（19度斜坡，最大速度0.58m/s行驶条件下测试数据）"},
    {name: "有线充电电流（时间）", value: "4A（3h）"},
    {name: "无线充电电流（时间）", value: "3A（3h30min）"},
    {name: "续航里程", value: "3.6km（0.2m/s平稳运行）"},
    {name: "巡检速度", value: "0.026-0.2m/s可设定"},
    {name: "检测气体", value: "烟雾，甲烷，一氧化碳，氧气，PM2.5，PM10（可选，可定制）"},
    {name: "摄像头旋转角度", value: "水平（25~355度） 垂直（75~180度）"},
    {name: "图像采集", value: "RGB网络摄像头，红外热成像"},
    {name: "声音采集", value: "驻极体电容麦"},
    {name: "避障方式", value: "前后激光雷达"},
    {name: "机器尺寸", value: "长378.5mmx217.2mmx高318mm"},
    {name: "行走机构", value: "4#角钢"},
    {name: "爬坡能力", value: "≤30°斜坡"},
    {name: "最小转向半径", value: "上：≥3.06m；下：≥0.94m；左：≥2.61m；右：≥0.89m（气体采集模组方向为前）"},
    {name: "夜视补光方式", value: "红外光辅助"},
    {name: "抗电磁干扰能力", value: "可在电磁和射频干扰下（频率400-500MHz，功率5W）正常工作"},
    {name: "防护等级", value: "IP65"},
    {name: "重量", value: "净重10.50kg（裸机）"},

]
let cicadaMAProvince = [
    {name: "工作温度", value: "-30～60℃"},
    {name: "存储温度", value: "-40～85℃"},
    {name: "工作湿度", value: "5～95%，无冷凝"},
]

let ladybugProductInfo = [
    {name: "适用领域", value: "中、长途带式输送机"},
    {name: "外形尺寸", value: "长345mm×宽280mm×高70mm"},
    {name: "整备重量", value: "8kg"},
    {name: "行走速度", value: "≤0.8m/s"},
    {name: "爬坡能力", value: "≥30°斜坡"},
    {name: "转向半径", value: "水平≥10m"},
    {name: "摄像头分辨率", value: "1080P"},
    {name: "热成像", value: "分辨率：256x192，测温范围：-20℃~+120℃"},
    {name: "烟雾传感器", value: "灵敏度：Rs（in air） Rs（1000ppm异丁烷）    ≥5"},
    {name: "拾音器", value: "20Hz~20kHz 115dB SPL"},
    {name: "定位方式", value: "RFID标签+里程计定位"},
    {name: "照明", value: "红外光辅助照明"},
    {name: "续航里程", value: "5km"},
    {name: "充电时长", value: "3小时"},
    {name: "额定电压", value: "24V"},
    {name: "额定电流", value: "0.8A"},
    {name: "抗干扰性", value: "可在电磁和射频干扰下（频率400-500MHz，功率5W）正常工作"},
    {name: "防护等级", value: "IP66"},

]
let ladybugProvince = [
    {name: "工作温度", value: "-30～60℃"},
    {name: "存储温度", value: "-40～85℃"},
    {name: "工作湿度", value: "5～95%，无冷凝"},
]
export  default {cicadaProductInfo,cicadaProvince,cicadaMAProductInfo,cicadaMAProvince,ladybugProductInfo,ladybugProvince}